import HistoricalSettlementInquiry from './historical-settlement-inquiry.vue'
export default HistoricalSettlementInquiry
